/** Icon.tsx */
import React from "react";
import { style, classes } from "./icon.st.css";
// Icons
import icons from "../../assets/icons.json";

/**
 * Icon component, takes icon name, title and optional class name.
 */
interface IconProps extends React.HTMLAttributes<HTMLSpanElement> {
  icon: string;
  title?: string;
}

const Icon = ({ icon, className, title, ...rest }: IconProps) => {
  // Get the SVG markup
  const svgContent = icons[icon] || "";
  // Modified SVG with the added title
  const modifiedSvg = svgContent.replace("{{title}}", title);

  return (
    <>
      {icons[icon] ? (
        <span
          className={style(classes.root, className)}
          {...rest}
          dangerouslySetInnerHTML={{ __html: modifiedSvg }}
        />
      ) : null}
    </>
  );
};

export default Icon;
